
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { IonicModule, ToastController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { EmptyPageModule } from '../empty-page/empty-page.module';
import { TranslateModule } from '@ngx-translate/core';
import { TeamDetailsService } from '../my-teams/team-details/team-details.service';
import { ToastService } from '../_core/services/toast.service';

@Component({
    selector: 'app-team-join',
    templateUrl: './team-join.component.html',
    styleUrls: ['./team-join.component.scss'],
    imports: [
        IonicModule,
        CommonModule,
        EmptyPageModule,
        TranslateModule
    ],
})
export class TeamJoinComponent implements OnInit {
    teamId: string;
    teamName: string; // will fetch from API
    loading = true;
    teamLogo: string;

    constructor(
        private route: ActivatedRoute,
        private teamService: TeamDetailsService,
        private toastCtrl: ToastService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.teamId = this.route.snapshot.paramMap.get('id')!;
        this.route.params.subscribe(params => {
            this.teamId = params['id'];
            if (this.teamId) {
                this.teamService.info(this.teamId).then(team => {
                    this.teamName = team.name;
                    this.teamLogo = team.logo || 'assets/img/avtar.png';
                    this.loading = false;
                }).catch(err => {
                    this.loading = false
                    this.toastCtrl.presentDangerToast(`Error fetching team info: ${err.message || err}`);
                    this.router.navigate(['/']); // go to home
                });
            } else {
            }
        });
    }

    joinTeam() {
        localStorage.removeItem('returnTo');
        this.teamService.joinTeam(this.teamId).subscribe((s) => {
            if (s.error) {
                this.toastCtrl.presentDangerToast(`Error joining team: ${s.error.message || s.error}`);
                return;
            }
            this.toastCtrl.presentToast(`You have joined ${this.teamName}!`);
            this.router.navigate(['/team', this.teamId]); // go to team page
        });
    }

    cancel() {
        localStorage.removeItem('returnTo');
        this.router.navigate(['/']);
    }

}